import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { resolveImage } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export const ProductCard = ({ product, index }) => {
  const { addItem } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08 }}
      className="group relative border border-white/10 hover:border-white/30 bg-[#0B120B] transition-colors duration-500"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#050805]">
        <img
          src={resolveImage(product.image_url)}
          alt={product.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B120B] via-transparent to-transparent" />
        {product.featured && (
          <span className="absolute top-4 left-4 bg-[#29FF87] text-[#050805] text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1">Featured</span>
        )}
        {!product.in_stock && (
          <span className="absolute top-4 right-4 bg-black/70 text-zinc-300 text-[10px] uppercase tracking-[0.2em] px-3 py-1 border border-white/20">Sold out</span>
        )}
      </div>

      <div className="p-6">
        <p className="font-body text-[10px] uppercase tracking-[0.3em] text-[#29FF87] mb-2">{product.substance || product.category}</p>
        <h3 className="font-grotesk font-bold text-lg tracking-tight leading-snug text-white">{product.name}</h3>
        <p className="mt-2 font-body text-sm text-[#B8E6C9] leading-relaxed line-clamp-2">{product.description}</p>

        <div className="mt-6 flex items-center justify-between">
          <span className="font-grotesk font-extrabold text-3xl price-neon">€{Number(product.price).toFixed(2)}</span>
          <button
            onClick={() => addItem(product)}
            disabled={!product.in_stock}
            className="flex items-center gap-2 border border-[#29FF87]/40 text-white hover:border-[#29FF87] hover:bg-[#29FF87] hover:text-[#050805] disabled:opacity-30 disabled:cursor-not-allowed px-4 py-2 font-body text-xs uppercase tracking-[0.2em] font-semibold transition-all duration-300"
            data-testid={`add-to-cart-${product.id}`}
          >
            <Plus size={14} /> Add
          </button>
        </div>
      </div>
    </motion.div>
  );
};
